import tw, { styled } from 'twin.macro';

export const StyledSection = styled.section<{ isReverseControlsPosition: boolean }>`
  ${tw`flex flex-col-reverse gap-3 lg:block`}
  ${tw`py-8`}
  ${({ isReverseControlsPosition }) =>
    isReverseControlsPosition ? tw`flex-col-reverse` : tw`flex-col`}
`;

export const StyledContainer = styled.div`
  ${tw`md:container`}
  ${tw`container-stack-context`}
  ${tw`flex flex-col-reverse gap-3 lg:grid lg:grid-cols-12 lg:gap-4`}
`;

export const StyledList = styled.ul<{
  isHiddenInMobile: boolean;
}>`
  ${tw`lg:col-span-4`}
  ${tw`sm:row-start-2 lg:row-start-1`}
  ${tw`lg:gap-3`}
  ${tw`flex-col`}
  ${({ isHiddenInMobile }) => (isHiddenInMobile ? tw`hidden lg:flex` : tw`flex`)}
`;

export const StyledListItem = styled.li<{
  isActive: boolean;
  isHiddenWhenNotActiveInMobile: boolean;
}>`
  ${tw`relative`}
  ${tw`p-2`}
  ${tw`cursor-pointer`}
  ${tw`bg-ui-colours-ui1`}
  ${tw`text-primary-p1`}
  ${tw`transition-all`}
  ${tw`border-solid border-4 border-ui-colours-ui1`}
  ${tw`rounded-lg`}

  ${tw`hover:border-ui-colours-ui3`}
  ${tw`focus:bg-ui-colours-ui1`}
  ${({ isActive }) =>
    isActive &&
    tw`border-secondary-s1 hover:border-secondary-s1 bg-neutrals-n1 hover:bg-neutrals-n1`}
  ${({ isActive, isHiddenWhenNotActiveInMobile }) =>
    isHiddenWhenNotActiveInMobile && !isActive && tw`hidden lg:block`}
`;

export const StyledTabTitle = styled.h3`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-heading-s`}
`;

export const StyledTabDescription = styled.p`
  ${tw`font-inter font-regular`}
  ${tw`text-body-m text-neutrals-n8`}
  ${tw`mt-1`}
`;

export const StyledContent = styled.div`
  ${tw`lg:col-span-8`}
  ${tw`row-start-1`}
  animation: fadein 0.8s;

  @keyframes fadein {
    from {
      opacity: 0.2;
    }
    to {
      opacity: 1;
    }
  }
`;

export const StyledTextWrapper = styled.div`
  ${tw`bg-ui-colours-ui1`}
  ${tw`px-2 py-5 md:p-5`}
  ${tw`md:rounded-2xl`}
`;

export const StyledImageWrapper = styled.div`
  ${tw`rounded-lg`}
  ${tw`overflow-hidden`}
`;

export const StyledControlContainer = styled.div`
  ${tw`lg:hidden`}
`;
